import React, { useEffect } from "react";
import { Container, Typography, Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "aos/dist/aos.css";
import AOS from "aos";

const Schools = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000 });
    AOS.refresh();
  }, []);

  return (
    <div
      style={{
        backgroundImage: `url(${require("../assets/images/landing_background.jpg")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        fontFamily: "'Baloo Bhaijaan 2', cursive",
        color: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      {/* Header */}
      <header
        style={{
          width: "100%",
          padding: "10px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.5)",
        }}
      >
        <img
          src={require("../assets/images/logo_name.PNG")}
          alt="YourStoryWorld Logo"
          style={{
            height: "40px",
            cursor: "pointer",
          }}
          onClick={() => navigate("/")}
        />
        <div>
          <Button color="inherit" onClick={() => navigate("/")}>
            Home
          </Button>
          <Button color="inherit" onClick={() => navigate("/login")}>
            Sign In
          </Button>
          <Button color="inherit" onClick={() => navigate("/help")}>
            Help
          </Button>
        </div>
      </header>

      {/* Main content */}
      <Container
        maxWidth="lg"
        style={{
          marginTop: "30px",
          marginBottom: "40px",
        }}
      >
        {/* Hero / intro block for schools – now with image alongside text */}
        <section
          style={{
            marginBottom: "50px",
            padding: "20px",
            backgroundColor: "rgba(0, 0, 0, 0.65)",
            borderRadius: "12px",
          }}
          data-aos="fade-up"
        >
          <Grid
            container
            spacing={4}
            alignItems="center"
            justifyContent="space-between"
          >
            {/* Text column */}
            <Grid item xs={12} md={7}>
              <Typography
                variant="h4"
                style={{ fontWeight: "bold", marginBottom: "10px" }}
              >
                A Literacy Platform Built for Schools Supporting Reading Engagement, Writing and AI Learning
              </Typography>
              <Typography
                variant="subtitle1"
                style={{ marginBottom: "16px" }}
              >
                Built for classrooms, literacy leads and MATs – with phonics
                support, analytics and school-controlled pupil accounts.
              </Typography>

              <Typography variant="body1">
                YourStoryWorld is an AI-powered literacy platform that helps schools make reading more engaging through personalised storytelling. It supports reading for pleasure, creative writing, comprehension and early AI literacy in a classroom-friendly way.
                <br />
                <br />
                Schools can tailor stories to curriculum goals, reinforce
                reading for pleasure, and use built-in dashboards to evidence
                reading activity and progress over time – useful for literacy leads, classroom teachers and wider whole-school reading priorities
              </Typography>

              <Typography
                variant="body2"
                style={{ marginTop: "14px", fontWeight: "bold" }}
              >
                For Headteachers, Literacy Leads &amp; MAT Directors:
              </Typography>
              <ul style={{ marginTop: 4, paddingLeft: "18px" }}>
                <li>Supports age-appropriate vocabulary and early reading development, with phonics-friendly features for younger learners.</li>
                <li>School and class dashboards for reading activity, engagement and progress monitoring.</li>
                <li>Pupil logins created and controlled by the school.</li>
                <li>UK GDPR-ready, with DPAs and security information available.</li>
              </ul>

              <div
                style={{
                  marginTop: "12px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => navigate("/subscriptions")}
                >
                  View School Plans
                </Button>
                <Button
                  variant="outlined"
                  style={{ borderColor: "white", color: "white" }}
                  onClick={() => navigate("/data-protection")}
                >
                  Data Protection for Schools
                </Button>
              </div>
            </Grid>

            {/* Image column */}
            <Grid
              item
              xs={12}
              md={5}
              style={{ textAlign: "center" }}
            >
              <img
                src={require("../assets/images/school_section2.jpg")}
                alt="Pupils using YourStoryWorld in class"
                style={{
                  width: "100%",
                  maxWidth: "360px",
                  borderRadius: "10px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
                }}
              />
            </Grid>
          </Grid>
        </section>

        {/* Empower Every Classroom - Features Summary */}
        <section
          style={{
            marginBottom: "60px",
            padding: "20px",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            borderRadius: "12px",
          }}
          data-aos="fade-up"
        >
          <Typography
            variant="h4"
            align="center"
            style={{ marginBottom: "20px", fontWeight: "bold" }}
          >
            Empower Every Classroom with These Key Features
          </Typography>
          <Grid container spacing={2}>
            {[
              { icon: "📚", label: "Curriculum-aligned vocabulary" },
              { icon: "📅", label: "Weekly teacher-assigned themes" },
              { icon: "🧠", label: "Comprehension quiz tracking" },
              { icon: "🎤", label: "Student voice recordings" },
              { icon: "📈", label: "Engagement analytics & class insights" },
              { icon: "🎯", label: "Goal tracking & story assignments" },
            ].map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Typography
                  variant="body1"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <span
                    style={{ fontSize: "1.5rem", marginRight: "10px" }}
                    aria-hidden="true"
                  >
                    {item.icon}
                  </span>
                  {item.label}
                </Typography>
              </Grid>
            ))}
          </Grid>
          
        </section>

        {/* Schools Introduction Section (original block) */}
        <section
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: "row-reverse",
            marginBottom: "40px",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              flex: 1,
              paddingLeft: "20px",
              minWidth: "300px",
              textAlign: "left",
            }}
          >
            <Typography>
              YourStoryWorld is an innovative AI-powered storytelling platform
              that makes reading and learning more engaging, personalized, and
              interactive for for primary-aged pupils and adaptable for wider age ranges. By allowing children to star in their own adventures, the platform fosters a deep love for
              reading while reinforcing key literacy skills such as
              comprehension, vocabulary building, and phonics. Schools can
              tailor stories to curriculum goals, ensuring that content aligns
              with age-appropriate language development and phonics progression.
              <br />
              <br />
              The built-in comprehension quizzes, interactive phonics support,
              and reading progress tracking help educators assess student
              performance in real-time, making it an invaluable tool for
              literacy development. Whether used in classrooms, libraries, or
              for independent reading assignments, YourStoryWorld supports literacy teaching through creativity and personalisation, encouraging students to
              become more engaged, confident readers while fostering a lifelong
              love for storytelling.
            </Typography>
          </div>
          <img
            src={require("../assets/images/schools_intro.jpg")}
            alt="YourStoryWorld in schools"
            style={{
              flex: 1,
              maxWidth: "400px",
              borderRadius: "10px",
              margin: "10px 0",
            }}
          />
        </section>

        {/* How Schools Use It / 2nd Section */}
        <section
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "40px",
            marginTop: "100px",
            flexWrap: "wrap",
          }}
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <div
            style={{
              flex: 1,
              paddingRight: "20px",
              minWidth: "300px",
              textAlign: "left",
            }}
          >
            <Typography
              variant="h4"
              style={{ marginBottom: "20px", fontWeight: "bold" }}
            >
              How Schools Use YourStoryWorld
            </Typography>
            <Typography component="div">
              Beyond fostering literacy and comprehension, YourStoryWorld
              transforms classroom learning into a dynamic and interactive
              experience. Schools typically use it to:
              <ul style={{ marginTop: 10, marginBottom: 10 }}>
                <li>Support guided reading and small-group interventions.</li>
                <li>
                  Set independent reading and writing tasks with built-in
                  comprehension questions.
                </li>
                <li>
                  Provide personalised homework and remote-learning reading
                  opportunities.
                </li>
                <li>
                  Celebrate pupil creativity by sharing printed or digital
                  collections of their stories.
                </li>
              </ul>
              With adjustable difficulty and personalisation, it helps teachers provide content that is better matched to pupils’ needs and interests. Group storytelling can support collaboration, while interactive elements can help maintain pupil engagement. Cross-curricular integration
              allows teachers to create stories that align with subjects like
              history, science, and social studies, making learning more
              immersive.
              <br />
              <br />
              By combining personalisation, interactivity, and measurable
              progress tracking, YourStoryWorld helps schools redefine literacy
              education, making reading a more inclusive, engaging, and
              enriching experience for students of all abilities.
            </Typography>
          </div>
          <img
            src={require("../assets/images/school_2.jpg")}
            alt="Classroom features"
            style={{
              flex: 1,
              maxWidth: "400px",
              borderRadius: "10px",
              margin: "10px 0",
            }}
          />
        </section>

        {/* 🔹 NEW: AI & Digital Literacy Section */}
        <section
          style={{
            marginBottom: "60px",
            padding: "24px 20px",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            borderRadius: "12px",
          }}
          data-aos="fade-up"
        >
          <Typography
            variant="h4"
            style={{ marginBottom: "16px", fontWeight: "bold" }}
          >
            Teaching AI &amp; Digital Literacy with YourStoryWorld
          </Typography>
          <Typography variant="body1" style={{ marginBottom: "12px" }}>
            Schools are increasingly looking for practical ways to help pupils understand how AI works, where it can go wrong, and how to use it safely and responsibly. YourStoryWorld gives you a
            practical, child-safe way to meet those expectations through
            everyday reading and writing.
          </Typography>
          <Typography variant="body2" style={{ marginBottom: "10px" }}>
            While pupils create and read stories, they can also:
          </Typography>
          <ul style={{ marginTop: 4, marginBottom: 10, paddingLeft: "20px" }}>
            <li>
              Explore how changing a <strong>prompt</strong> changes the story
              (audience, tone, length, genre).
            </li>
            <li>
              Practise spotting when AI is <strong>incorrect, exaggerated or
              unrealistic</strong>, and rewrite those parts.
            </li>
            <li>
              Compare an AI-generated story with <strong>non-fiction sources</strong> to
              separate fact from fiction.
            </li>
            <li>
              Discuss <strong>safe, responsible use of AI</strong> in line with computing
              and digital literacy guidance.
            </li>
          </ul>
          <Typography variant="body2" style={{ marginBottom: "16px" }}>
            We provide a dedicated <strong>AI for Schools overview</strong> and a full{" "}
            <strong>Teacher Guide with lesson ideas</strong> so staff can build AI
            literacy into English, computing and PSHE without needing extra platforms.
          </Typography>

          <div
            style={{
              marginTop: "8px",
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/ai-for-schools")}
            >
              AI for Schools Overview
            </Button>
            <Button
              variant="outlined"
              style={{ borderColor: "white", color: "white" }}
              onClick={() => navigate("/ai-for-schools-page")}
            >
              AI Teacher Guide &amp; Lesson Ideas
            </Button>
          </div>
        </section>

        {/* Phonics Support Section */}
        <section
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "60px",
            marginTop: "100px",
            flexWrap: "wrap",
          }}
          data-aos="fade-right"
        >
          <div
            style={{
              flex: 1,
              paddingRight: "20px",
              minWidth: "300px",
              textAlign: "left",
            }}
          >
            <Typography
              variant="h4"
              style={{ marginBottom: "20px", fontWeight: "bold" }}
            >
              Phonics Support Built-In
            </Typography>
            <Typography component="div">
              YourStoryWorld includes phonics-friendly features for younger learners, such as highlighted decodable words, syllable support and audio narration. These features are designed to complement early reading practice while keeping stories engaging and enjoyable.
              <br />
              <br />
              Using a combination of AI and structured phonics mapping, the app:
              <ul style={{ textAlign: "left", marginTop: "10px" }}>
                <li>
                  Emphasises common phonics patterns (like “sh,” “ch,” “ai,”
                  etc.)
                </li>
                <li>Breaks words into syllables with subtle pauses</li>
                <li>
                  Allows children to <strong>listen to phoneme-level pronunciation</strong>
                </li>
                <li>
                  Provides visual cues to associate sound with spelling
                </li>
              </ul>
              Whether used during lessons or independent reading time, it
              supports synthetic phonics instruction while keeping reading
              engaging and fun.
            </Typography>
          </div>
          <img
            src={require("../assets/images/phonics_example.jpg")}
            alt="Phonics Support"
            style={{
              flex: 1,
              maxWidth: "400px",
              borderRadius: "10px",
              margin: "10px 0",
            }}
            data-aos="fade-left"
          />
        </section>

        {/* Contact Section */}
        <section style={{ marginBottom: "40px" }} data-aos="fade-up">
          <Typography
            variant="h4"
            style={{ marginBottom: "20px", fontWeight: "bold" }}
          >
            Talk to Us About Your School
          </Typography>
          <Typography>
            Interested in a pilot, staff demo or MAT-wide rollout? Get in touch
            at{" "}
            <a
              href="mailto:support@yourstoryworld.com"
              style={{ color: "white", textDecoration: "underline" }}
            >
              support@yourstoryworld.com
            </a>{" "}
            or use the{" "}
            <a
              href="/contact"
              style={{ color: "white", textDecoration: "underline" }}
            >
              Contact page
            </a>{" "}
            and we’ll be happy to discuss what would work best for your setting.
          </Typography>
        </section>

        {/* Mini Case Studies / School Testimonials */}
        <section
          style={{
            marginTop: "60px",
            marginBottom: "60px",
            padding: "20px",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            borderRadius: "12px",
          }}
          data-aos="fade-up"
        >
          <Typography
            variant="h4"
            align="center"
            style={{ fontWeight: "bold", marginBottom: "30px" }}
          >
            Early Feedback from Schools
          </Typography>

          <Grid container spacing={4}>
            {/* Testimonial 1 */}
            <Grid item xs={12} md={4}>
              <div
                style={{
                  background: "rgba(255, 247, 200, 0.95)",
                  padding: "16px",
                  borderRadius: "10px",
                  borderTop: "4px solid #FACC15",
                  color: "#333",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                  height: "100%",
                }}
              >
                <Typography style={{ marginBottom: "10px" }}>
                  “We're seeing pupils more motivated to read. Even reluctant readers are
                  choosing to engage because they’re in the stories!”
                </Typography>
                <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                  ⭐ Literacy Lead, Birmingham
                </Typography>
              </div>
            </Grid>

            {/* Testimonial 2 */}
            <Grid item xs={12} md={4}>
              <div
                style={{
                  background: "rgba(255, 247, 200, 0.95)",
                  padding: "16px",
                  borderRadius: "10px",
                  borderTop: "4px solid #FACC15",
                  color: "#333",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                  height: "100%",
                }}
              >
                <Typography style={{ marginBottom: "10px" }}>
                  “YourStoryWorld has made guided reading smoother & quicker — instant stories set
                  to our topics, with comprehension questions built in.”
                </Typography>
                <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                  ⭐ Year 4 Teacher, West Midlands
                </Typography>
              </div>
            </Grid>

            {/* Testimonial 3 */}
            <Grid item xs={12} md={4}>
              <div
                style={{
                  background: "rgba(255, 247, 200, 0.95)",
                  padding: "16px",
                  borderRadius: "10px",
                  borderTop: "4px solid #FACC15",
                  color: "#333",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                  height: "100%",
                }}
              >
                <Typography style={{ marginBottom: "10px" }}>
                  “The analytics dashboard is brilliant. We finally have visibility of
                  real reading engagement — not just test scores.”
                </Typography>
                <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                  ⭐ Assistant Headteacher, London
                </Typography>
              </div>
            </Grid>
          </Grid>
        </section>
      </Container>

      {/* Footer – consistent with the rest of the site */}
      <footer
        style={{
          textAlign: "center",
          padding: "20px",
          backgroundColor: "#000",
          color: "#fff",
        }}
      >
        <Typography>
          © {new Date().getFullYear()} YOURSTORYWORLD LTD · All Rights
          Reserved
        </Typography>
        <Typography variant="body2">
          <a href="/about" style={footerLink}>
            About Us
          </a>{" "}
          |{" "}
          <a href="/contact" style={footerLink}>
            Contact
          </a>{" "}
          |{" "}
          <a href="/feedback" style={footerLink}>
            Feedback
          </a>{" "}
          |{" "}
          <a href="/privacy-policy" style={footerLink}>
            Privacy Policy
          </a>{" "}
          |{" "}
          <a href="/terms" style={footerLink}>
            Terms of Use
          </a>{" "}
          |{" "}
          <a href="/cookie-policy" style={footerLink}>
            Cookie Policy
          </a>{" "}
          |{" "}
          <a href="/child-safety" style={footerLink}>
            Child Safety
          </a>{" "}
          |{" "}
          <a href="/data-protection" style={footerLink}>
            Schools Data Protection
          </a>
        </Typography>
        <Typography
          variant="caption"
          style={{ marginTop: "10px", display: "block", color: "#ccc" }}
        >
          ⚠️ Disclaimer: The stories generated by YourStoryWorld are created using
          AI and are intended for entertainment and educational purposes only.
          While we strive for accuracy, some content may contain factual or
          narrative inconsistencies.
          <p style={{ fontSize: "0.8rem", color: "#e11d48", marginTop: "10px" }}>
            <strong>Child-Safe Content:</strong> YourStoryWorld uses AI safety filters to ensure all stories
            remain age-appropriate. Violent, explicit, discriminatory, or harmful content is automatically
            removed or rewritten. Minor variance may occur due to the nature of AI generation.
          </p>
        </Typography>
      </footer>
    </div>
  );
};

const footerLink = {
  color: "white",
  textDecoration: "none",
};

export default Schools;
